module.exports = __webpack_public_path__ + "img/pr-17.d521aa3f.png";